/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModelInfo } from '../../models/model-info';

export interface GetModel$Params {
  modelRef: string;
}

export function getModel(http: HttpClient, rootUrl: string, params: GetModel$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelInfo>> {
  const rb = new RequestBuilder(rootUrl, getModel.PATH, 'get');
  if (params) {
    rb.query('modelRef', params.modelRef, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelInfo>;
    })
  );
}

getModel.PATH = '/v0/FocoosAI/model-info';
